// Import JS Modules
import { builderDispatch, WebUI } from '../_utils/ui';

window.fireAddedToCartOmniAnalytics = function(addedItem) {
  builderDispatch.dispatch({
    type: WebUI.ADD_TO_CART,
    item: addedItem,
  });
};

// -----------------------------------------------------------
//  addedToCartOmniAnalytics
// -----------------------------------------------------------
builderDispatch.register(payload => {
  if (typeof s_omni !== 'object') {
    return;
  }
  if (payload.type !== WebUI.ADD_TO_CART) {
    return;
  }

  const item = payload.item || {};

  const omni = {
    adid: s_omni.getQueryParam('adid'),
    fbref: s_omni.getQueryParam('fb_ref'),
    sourceid: s_omni.getQueryParam('sourceid'),
    povid: s_omni.getQueryParam('povid'),
    findingMethod: s_omni.getQueryParam('findingMethod'),
    getCampaignId() {
      if (this.adid) {
        return this.adid;
      }
      if (this.fbref) {
        return this.fbref.split('_')[1];
      }
      if (this.sourceid) {
        return this.sourceid;
      }
      return '';
    },
  };
  s_omni.campaign = omni.getCampaignId();
  s_omni.channel = window.location.hostname;

  const breadcrumbs = item.breadcrumbs || [];
  let breadcrumb = makeBreadcrumbString(breadcrumbs);
  let category = '';

  if (breadcrumbs[0] && breadcrumbs[0].name) {
    category = breadcrumbs[0].name;
  }

  s_omni.pageName = 'Shopping Persistent Cart';
  s_omni.events = 'scAdd';
  s_omni.prop1 = 'Cart'; // Page type
  s_omni.prop2 = 'Shopping Persistent Cart';
  s_omni.prop3 = category;
  s_omni.prop4 = '';
  s_omni.prop5 = breadcrumb;
  s_omni.prop8 = 'Walmart Photo: LiveLink';

  /* Syntax: ="Category;ProductID;Quantity;Total Price;eVar30=vendor name"; */
  s_omni.products = [
    'walmartphotocenter:',
    item.partner_id || item.upc,
    item.copies,
    item.price_without_currency,
    '',
    'evar30=Walmart.com',
  ].join(';');

  s_omni.t(); // track

  function makeBreadcrumbString(breadcrumbs) {
    let breadcrumb = '';
    for (let i = 0; i < breadcrumbs.length; i++) {
      if (i === 0) {
        breadcrumb = breadcrumbs[i].name;
      } else {
        breadcrumb += `: ${breadcrumbs[i].name}`;
      }
    }
    return breadcrumb;
  }
});
